import axios from "axios";
import { useQuery } from "react-query";
import { HiUserGroup } from "react-icons/hi";
import { LuRefreshCw } from "react-icons/lu";
import { IoRestaurant, IoCartSharp } from "react-icons/io5";
import { useEffect, useMemo } from "react";
import { Loader } from "../components/Loader";
import { Table } from "../components/Table";

export const Home = () => {
  const {
    data: statistics,
    isLoading: statisticsLoading,
    refetch: statisticsRefetch,
  } = useQuery("Get Statistics", async () => {
    const response = await axios.get("/statistics");
    return response.data.statistics;
  });

  const {
    data: orderslogs,
    isLoading: orderslogsLoading,
    refetch: orderslogsRefetch,
    isFetching: orderslogsFetching,
  } = useQuery("Get Orders logs", async () => {
    const response = await axios.get("/order/logs");
    return response.data.orders;
  });

  const liveOrdersColumns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "id",
      },
      {
        Header: "Restaurant",
        accessor: "restaurantName",
      },
      {
        Header: "Branch",
        accessor: "branchName",
      },
      {
        Header: "Category",
        accessor: "category",
      },
      {
        Header: "Total",
        accessor: "totalPrice",
      },
      {
        Header: "Payment",
        accessor: "payment",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Time",
        accessor: "time",
      },
    ],
    []
  );

  const events = [
    {
      message: "orderLogsUpdate",
      onReceive: async () => {
        orderslogsRefetch();
      },
    },
  ];

  useEffect(() => {
    const eventSource = new EventSource(axios.defaults.baseURL + "events");

    events.forEach((event) => {
      eventSource.addEventListener(event.message, event.onReceive);
    });

    eventSource.onerror = (err) => {
      console.error("SSE error:", err);
    };

    return () => {
      eventSource.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    statisticsRefetch();
    orderslogsRefetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (statisticsLoading)
    return (
      <div className="flex justify-center items-center pt-32">
        <Loader />
      </div>
    );

  return (
    <div>
      <div className="grid grid-cols-12 gap-8 px-4 py-10">
        <a href="/users" className="col-span-12 lg:col-span-4 cursor-pointer">
          <div className="flex items-center gap-4 bg-gray-100 text-green-600 px-10 md:px-4 py-6 rounded-xl border-[1px] border-gray-300 font-bold text-2xl">
            <div className="flex justify-center items-center bg-green-600 p-3 md:p-2 rounded-full">
              <HiUserGroup className="text-4xl text-white" />
            </div>
            <p className="text-3xl">{statistics?.users}</p>
            <p className="font-semibold">Users</p>
          </div>
        </a>

        <a
          href="restaurants"
          className="col-span-12 lg:col-span-4 cursor-pointer"
        >
          <div className="flex items-center gap-4 bg-gray-100 text-green-600 px-10 md:px-4 py-6 rounded-xl border-[1px] border-gray-300 font-bold text-2xl">
            <div className="flex justify-center items-center bg-green-600 p-3 md:p-2 rounded-full">
              <IoRestaurant className="text-4xl text-white" />
            </div>
            <p className="text-3xl">{statistics?.restaurants}</p>
            <p className="font-semibold">Restaurants</p>
          </div>
        </a>

        <a href="/" className="col-span-12 lg:col-span-4 cursor-pointer">
          <div className="flex items-center gap-4 bg-gray-100 text-green-600 px-10 md:px-4 py-6 rounded-xl border-[1px] border-gray-300 font-bold text-2xl">
            <div className="flex justify-center items-center bg-green-600 p-3 md:p-2 rounded-full">
              <IoCartSharp className="text-4xl text-white" />
            </div>
            <p className="text-3xl">{statistics?.orders}</p>
            <p className="font-semibold">Orders</p>
          </div>
        </a>

        <div className="h-fit col-span-12 flex flex-col gap-4 bg-gray-100 px-10 py-6 rounded-xl border-[1px] border-gray-300">
          <div className="flex items-center justify-between ">
            <h1 className="text-2xl font-bold text-green-600">Live Orders</h1>
            <div>
              <LuRefreshCw
                onClick={() => orderslogsRefetch()}
                className={`${
                  (orderslogsLoading || orderslogsFetching) && "animate-spin"
                } " text-2xl text-green-600 cursor-pointer "`}
              />
            </div>
          </div>
          {orderslogs?.length === 0 && <div>Doesn't exist Orders</div>}
          {orderslogs && (
            <Table columns={liveOrdersColumns} data={orderslogs} />
          )}
        </div>
      </div>
    </div>
  );
};
